(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-bo-quick-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mo-bo-quick-buy')) return;

    class MoBoQuickBuy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add.js';
        this.cartUrl = this.dataset.cartUrl || '/cart.js';

        this.querySelectorAll('[data-ombq-card]').forEach((card) => this.initializeCard(card));
        if ('IntersectionObserver' in window) {
          this.mobileBarObserver = new IntersectionObserver((entries) => {
            document.body.classList.toggle('ombq-mobile-in-view', entries[0].isIntersecting);
          }, { rootMargin: '-80px 0px -20% 0px' });
          this.mobileBarObserver.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.mobileBarObserver) this.mobileBarObserver.disconnect();
        document.body.classList.remove('ombq-mobile-in-view');
      }

      initializeCard(card) {
        const json = card.querySelector('[data-ombq-variants]');
        if (!json) return;

        try {
          card._ombqVariants = JSON.parse(json.textContent || '[]');
        } catch (error) {
          card._ombqVariants = [];
        }

        const initialId = Number(card.dataset.initialVariant);
        const initialVariant = card._ombqVariants.find((variant) => Number(variant.id) === initialId)
          || card._ombqVariants.find((variant) => variant.available)
          || card._ombqVariants[0];

        if (initialVariant) this.applyVariant(card, initialVariant, true);

        card.querySelectorAll('.ombq-swatch').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const group = button.closest('[data-option-position]');
            group.querySelectorAll('.ombq-swatch').forEach((item) => {
              const selected = item === button;
              item.classList.toggle('is-selected', selected);
              item.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
            this.resolveVariant(card, Number(group.dataset.optionPosition), button.dataset.optionValue);
          });
        });

        card.querySelectorAll('[data-ombq-select]').forEach((select) => {
          select.addEventListener('change', () => {
            const group = select.closest('[data-option-position]');
            this.resolveVariant(card, Number(group.dataset.optionPosition), select.value);
          });
        });

        const addButton = card.querySelector('[data-ombq-add]');
        if (addButton) addButton.addEventListener('click', () => this.addToCart(card));
      }

      selectedOptions(card) {
        const selected = [];
        card.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = Number(group.dataset.optionPosition) - 1;
          const select = group.querySelector('[data-ombq-select]');
          const swatch = group.querySelector('.ombq-swatch.is-selected');
          selected[position] = select ? select.value : (swatch ? swatch.dataset.optionValue : '');
        });
        return selected;
      }

      resolveVariant(card, changedPosition, changedValue) {
        const selected = this.selectedOptions(card);
        const exact = card._ombqVariants.find((variant) => {
          return variant.options.every((value, index) => value === selected[index]);
        });

        let nextVariant = exact;
        if (!nextVariant || !nextVariant.available) {
          const changedIndex = changedPosition - 1;
          nextVariant = card._ombqVariants.find((variant) => {
            return variant.available && variant.options[changedIndex] === changedValue;
          });
        }

        if (nextVariant) this.applyVariant(card, nextVariant, true);
      }

      applyVariant(card, variant, updateControls) {
        card.dataset.variantId = variant.id;
        card.dataset.variantAvailable = variant.available ? 'true' : 'false';

        if (updateControls) {
          card.querySelectorAll('[data-option-position]').forEach((group) => {
            const optionIndex = Number(group.dataset.optionPosition) - 1;
            const value = variant.options[optionIndex];
            const select = group.querySelector('[data-ombq-select]');
            if (select) select.value = value;
            group.querySelectorAll('.ombq-swatch').forEach((button) => {
              const selected = button.dataset.optionValue === value;
              button.classList.toggle('is-selected', selected);
              button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
          });
        }

        const price = card.querySelector('[data-ombq-price]');
        const compare = card.querySelector('[data-ombq-compare]');
        if (price) price.textContent = this.formatMoney(variant.price);
        if (compare) {
          const showCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
          compare.textContent = showCompare ? this.formatMoney(variant.compare_at_price) : '';
          compare.classList.toggle('is-hidden', !showCompare);
        }

        const variantImage = variant.featured_image && variant.featured_image.src;
        const image = card.querySelector('.ombq-card__image:not(.ombq-card__placeholder)');
        if (variantImage && image) {
          image.src = variantImage;
          image.removeAttribute('srcset');
        }

        const addButton = card.querySelector('[data-ombq-add]');
        const addLabel = card.querySelector('[data-ombq-add-label]');
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';

        this.updateOptionAvailability(card);
      }

      updateOptionAvailability(card) {
        const selected = this.selectedOptions(card);

        card.querySelectorAll('[data-option-position]').forEach((group) => {
          const optionIndex = Number(group.dataset.optionPosition) - 1;
          const controls = group.querySelectorAll('[data-option-value], option');

          controls.forEach((control) => {
            const value = control.dataset.optionValue || control.value;
            const viable = card._ombqVariants.some((variant) => {
              if (!variant.available || variant.options[optionIndex] !== value) return false;
              return variant.options.every((variantValue, index) => {
                return index === optionIndex || !selected[index] || variantValue === selected[index];
              });
            });
            control.disabled = !viable;
          });
        });
      }

      async addToCart(card) {
        const button = card.querySelector('[data-ombq-add]');
        const label = card.querySelector('[data-ombq-add-label]');
        const status = card.querySelector('[data-ombq-status]');
        const variantId = Number(card.dataset.variantId);
        if (!button || !variantId || button.disabled) return;

        button.disabled = true;
        button.classList.add('is-loading');
        if (label) label.textContent = 'Wird hinzugefügt';
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          const payload = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Das Produkt konnte nicht hinzugefügt werden.');
          }

          const cartResponse = await fetch(this.cartUrl, {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
          const cart = cartResponse.ok ? await cartResponse.json() : null;

          if (label) label.textContent = 'Hinzugefügt';
          if (status) status.textContent = 'Liegt jetzt im Warenkorb.';
          this.notifyCartUpdated(cart, payload);

          window.setTimeout(() => {
            if (label) label.textContent = 'In den Warenkorb';
            button.disabled = card.dataset.variantAvailable !== 'true';
          }, 1600);
        } catch (error) {
          if (label) label.textContent = 'Erneut versuchen';
          if (status) {
            status.textContent = error.message || 'Das Produkt konnte nicht hinzugefügt werden.';
            status.classList.add('is-error');
          }
          button.disabled = false;
        } finally {
          button.classList.remove('is-loading');
        }
      }

      notifyCartUpdated(cart, addedItem) {
        const detail = { cart: cart, item: addedItem, source: 'mo-bo-quick-buy' };
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true, detail: detail }));
        document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true, detail: detail }));

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2).replace('.', ',') + ' €';
        }
      }
    }

    customElements.define('mo-bo-quick-buy', MoBoQuickBuy);
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-home-advice"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ol-showroom-gallery')) {
  customElements.define('ol-showroom-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelectorAll('[data-showroom-select]').forEach(button => {
        button.addEventListener('click', () => {
          const selected = Number(button.dataset.showroomSelect);
          this.querySelectorAll('[data-showroom-panel]').forEach((panel, index) => {
            panel.hidden = index !== selected;
          });
          this.querySelectorAll('[data-showroom-select]').forEach((item, index) => {
            item.setAttribute('aria-pressed', String(index === selected));
          });
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-service-entry"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-service-offer]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.OptileanOfferList?.open !== 'function') return;
    event.preventDefault();
    window.OptileanOfferList.open();
  });

  } catch(e) { console.error(e); }
})();
})();
